<template>
    <div class="range-metric px-2">
        <span class="text-bold text-light-2" :class="metricTitle ? 'mb-1' : 'mb-4'">
            {{ $translate(rangeMetric.systemName) }}
        </span>

        <span v-if="metricTitle" class="title mb-4">{{ $translate(metricTitle) }}</span>

        <div class="range-metric-element rounded-pill">
            <div class="range-metric-marker" :style="`left: ${normalizedValue * 100}%`">
                <div class="range-metric-marker-pointer-top" :class="valueColor">
                    <span>{{ $uiUtils.formatNumber(value, 0) }}</span>
                </div>

                <div class="range-metric-marker-pointer" :class="valueColor + '-pointer'"></div>
            </div>
        </div>

        <div class="display-flex">
            <div class="ml-1 mr-auto">{{ $uiUtils.formatNumber(rangeMetric.min, 0) }}</div>
            <div>{{ $uiUtils.formatNumber(rangeMetric.max, 0) }}</div>
        </div>
    </div>
</template>

<script>
import Theme from '../../../business/utils/Theme'

export default {
    name: 'RangeMetric',
    props: {
        rangeMetric: {
            type: Object,
            required: true
        },
        lowHighThresholds: {
            type: Array,
            default: () => [30, 70]
        },
        metricTitle: {
            type: String,
            default: ''
        }
    },
    computed: {
        value() {
            return this.rangeMetric.value
        },
        normalizedValue() {
            const { min, max } = this.rangeMetric

            return max - min !== 0 ? (this.value - min) / (max - min) : 0
        },
        valueColor() {
            return this.value > this.lowHighThresholds[0]
                ? this.value > this.lowHighThresholds[1]
                    ? Theme.ragClasses.background.green
                    : Theme.ragClasses.background.amber
                : Theme.ragClasses.background.red
        }
    }
}
</script>

<style lang="scss" scoped>
.range-metric {
    display: flex;
    flex-direction: column;
    color: $light;

    .title {
        font-size: 10pt;
        color: $light;
    }

    .range-metric-element {
        position: relative;
        width: 100%;
        height: 0.8rem;
        background-color: $dark-5;

        .range-metric-marker {
            width: 1.5rem;
            height: 1rem;
            display: flex;
            align-items: center;
            flex-direction: column;
            position: absolute;
            top: -1.2rem;
            background-color: $light;
            border-radius: 0.1rem;
            margin-left: -0.7rem;
            box-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.5);

            .range-metric-marker-pointer-top {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 0.2rem;

                span {
                    font-size: 10pt;
                    color: $dark;
                }
            }
            .range-metric-marker-pointer {
                border-radius: 0.2rem;
                height: 0.8rem;
                margin-top: -0.1rem;
                border-left: 0.75rem solid transparent;
                border-right: 0.75rem solid transparent;
            }
        }
    }
}
</style>
